import React, { useEffect, useState } from 'react';
import { FaSquareCaretRight, FaSquareCaretLeft, FaArrowUpRightFromSquare } from 'react-icons/fa6';
import {Link} from 'react-router-dom';
import '../../css/pages/portfolio.css';

function PortfolioFramework({ items }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Reset to first item whenever the list changes
  React.useEffect(() => {
    if (items && items.length > 0) {
      setCurrentIndex(0);
    }
  }, [items]);

  React.useEffect(() => {
    if (!items || items.length === 0) return;

    setImageLoaded(false);
    const currentItem = items[currentIndex];
    if (!currentItem) return;

    const img = new Image();
    img.src = currentItem.imgUrl;
    img.onload = () => setImageLoaded(true);
    img.onerror = () => setImageLoaded(true); // handle broken images too
  }, [items, currentIndex]);

  if (!items || items.length === 0) {
    return <p>No portfolio items to display.</p>;
  }

  const currentItem = items[currentIndex];
  if (!currentItem) return <p>No portfolio items to display.</p>;

  const adjustIndex = (operator) => {
    if (!items || items.length === 0) return;
    setCurrentIndex((prevIndex) => {
      if (operator === '+') {
        return (prevIndex + 1) % items.length;
      } else if (operator === '-') {
        return (prevIndex - 1 + items.length) % items.length;
      }
      return prevIndex;
    });
  };

  return (
    <div className="portfolio-framework">
      <div className="portfolio-frame f-col">
      {!imageLoaded && (
        <h3 className="info-title">"Loading..."</h3>
      )}
      {imageLoaded && (
      <div className="image-frame">
        <img
        className="portfolio-preview"
        src={currentItem.imgUrl}
        alt={currentItem.title}
        />
      </div>
      )}
      <h4 className="portfolio-title">{currentItem.title}</h4>
      <p className="portfolio-description">{currentItem.description}</p>

      <Link to={`/collaborators`} className="collaborators-list">
      {currentItem.collaborators?.length > 0 && (
          <p>
            {currentItem.collaborators.join(", ")}
          </p>
      )}
      </Link>
      </div>

      <div className="w-100 flex space-between">
        <FaSquareCaretLeft
          className="info-link btn icon-hover"
          onClick={() => adjustIndex('-')}
          />
        <a
          href={currentItem.linkUrl}
          className="btn info-link icon-hover"
          title="Launch Site"
          target="_blank"
          rel="noopener noreferrer"
          >
          <FaArrowUpRightFromSquare />
        </a>
        <FaSquareCaretRight
          className="btn info-link icon-hover"
          onClick={() => adjustIndex('+')}
          />
        </div>
    </div>
  );
}

export default PortfolioFramework;